var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"documents-section",attrs:{"aria-label":"Documentos oficiales"}},[_c('div',{staticClass:"container"},[_c('tabs-section')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }